export default "__VITE_ASSET__g6J0$y8U__"